"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Rudderstack", {
    enumerable: true,
    get: function() {
        return Rudderstack;
    }
});
var _interop_require_default = require("@swc/helpers/_/_interop_require_default");
var _object_spread = require("@swc/helpers/_/_object_spread");
var _object_spread_props = require("@swc/helpers/_/_object_spread_props");
var _to_consumable_array = require("@swc/helpers/_/_to_consumable_array");
var _analyticsjs = require("@rudderstack/analytics-js");
var _lodashisequal = /*#__PURE__*/ _interop_require_default._(require("lodash.isequal"));
var _didomi = require("../../providers/didomi");
var _constants = require("./constants");
var _constants1 = require("../../constants");
var _batchBuffer = require("./batchBuffer");
var _logger = require("../../helpers/logger");
var _cookie = require("../../helpers/cookie");
var _setVisitorId = require("../../helpers/setVisitorId");
var _runCallback = require("../../helpers/runCallback");
var _defineDefaultContentType = require("../../helpers/defineDefaultContentType");
var _getPageViewCategoryAccordingToTheStack = require("../../helpers/getPageViewCategoryAccordingToTheStack");
var _refererParams = require("../../helpers/refererParams");
var _sendUserConsents = require("../../providers/didomi/sendUserConsents");
var _utils = require("./utils");
var defaultSdk = {
    didomi: {
        privacyPolicyURL: "",
        enabled: true,
        noticeId: ""
    },
    rudderstack: {
        dataPlaneURL: "",
        jsKey: "",
        enabled: true
    }
};
var Rudderstack = function Rudderstack() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _sdk_didomi, _sdk_didomi1;
    var debug = config.debug, _config_sdk = config.sdk, sdk = _config_sdk === void 0 ? defaultSdk : _config_sdk, batchConfigUrl = config.batchConfigUrl, _config_locale = config.locale, locale = _config_locale === void 0 ? "en" : _config_locale, _config_sessionId = config.sessionId, sessionId = _config_sessionId === void 0 ? null : _config_sessionId, _config_startRudderstackOnInit = config.startRudderstackOnInit, startRudderstackOnInit = _config_startRudderstackOnInit === void 0 ? true : _config_startRudderstackOnInit, _config_context = config.context, context = _config_context === void 0 ? {} : _config_context;
    var tmp = context.is_not_a_bot, isNotABot = tmp === void 0 ? true : tmp, tmp1 = context.user_country, userCountry = tmp1 === void 0 ? null : tmp1;
    var userAgent = window.navigator.userAgent;
    var isBot = _constants.BOT_AGENTS.some(function(bot) {
        return userAgent.includes(bot);
    }) || !isNotABot;
    var logger = (0, _logger.getLogger)(debug);
    logger.info("⏳ Rudderstack - init");
    var batchBuffer = (0, _batchBuffer.BatchBuffer)(batchConfigUrl || "", logger);
    if (!window.rudderanalytics) {
        window.rudderanalytics = new _analyticsjs.RudderAnalytics();
        window.rudderstackIsLoaded = false;
    }
    var isQueueNeeded = function() {
        return !batchBuffer.isReady() || !window.rudderstackIsLoaded;
    };
    var skipBot = function(trackFn) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (isBot) {
                logger.info("Skip tracking for bot");
                return;
            }
            trackFn.apply(void 0, _to_consumable_array._(args));
        };
    };
    var rudderAnalytics = window.rudderanalytics;
    // The eventsQueue is only used while RS & batchBuffer are being initialized
    var eventsQueue = [];
    /**
   * priority: lower number = higher priority = event sent first
   * priority 0: identify (sent first)
   * priority 1: page
   * priority 100 (default): track + re-identify
   */ function queueEvent(param) {
        var eventFunc = param.eventFunc, args = param.args, _param_priority = param.priority, priority = _param_priority === void 0 ? 100 : _param_priority;
        logger.info("⏳ Rudderstack - Add delayed event", {
            eventFunc: eventFunc,
            args: args,
            priority: priority
        });
        eventsQueue.push({
            event: eventFunc,
            args: args,
            priority: priority
        });
    }
    var flushEventsQueue = function() {
        var _eventItem;
        logger.info("\uD83D\uDE4B Rudderstack - ready to flushEventsQueue ?");
        if (!batchBuffer.isReady()) {
            logger.info("⏳ Rudderstack - BatchBuffer not ready, wait before flush");
            batchBuffer.onReady(flushEventsQueue);
            return;
        }
        logger.info("⛳ Rudderstack - ready to flushEventsQueue");
        var currentQueue = eventsQueue.sort(function(eventA, eventB) {
            return eventA.priority - eventB.priority;
        });
        logger.info("⏳ Rudderstack - Delayed events list >", currentQueue);
        currentQueue.forEach(function(eventItem) {
            return (_eventItem = eventItem).event.apply(_eventItem, _to_consumable_array._(eventItem.args));
        });
        eventsQueue = [];
        logger.info("\uD83D\uDDD1️ Rudderstack - The event queue is cleared ✅");
    };
    (0, _setVisitorId.setVisitorId)();
    var loadRudderstack = function() {
        if (window.rudderstackIsLoaded) {
            logger.debug("⛳ Rudderstack already ready and available in the window container");
            flushEventsQueue();
            return;
        }
        if (!sdk) {
            logger.error("Missing RS SDK credentials");
            return;
        }
        if (sdk.rudderstack.enabled === false) {
            logger.info("RS is not enabled");
            return;
        }
        rudderAnalytics = rudderAnalytics;
        rudderAnalytics.load(sdk.rudderstack.jsKey, sdk.rudderstack.dataPlaneURL, {
            logLevel: debug ? _constants.LOG_LEVELS.DEBUG : _constants.LOG_LEVELS.INFO,
            configUrl: _constants.SDK_HOST_URL,
            pluginsSDKBaseURL: "".concat(_constants.SDK_HOST_URL, "/beta/3.0.0-beta/modern/plugins"),
            storage: {
                type: "cookieStorage",
                encryption: {
                    // TODO: set to v3 once everyone uses the new version of js-tracking
                    version: "legacy"
                },
                // TODO: set to true once everyone uses the new version of js-tracking
                migrate: false
            },
            // TODO: change once everyone uses the new version of js-tracking
            // plugins: ["DeviceModeDestinations", "StorageEncryption", "StorageMigrator", ],
            plugins: [
                "DeviceModeDestinations",
                "StorageEncryptionLegacy"
            ]
        });
        rudderAnalytics.ready(function() {
            logger.info("⛳ Rudderstack is ready");
            window.rudderstackIsLoaded = true;
            flushEventsQueue();
        });
    };
    var sessionIsStartedRudderstack = function() {
        // TODO: find how to avoid having to cast "as RudderAnalytics" everywhere
        var sessionIsStarted = !!rudderAnalytics.getSessionId();
        logger.info("\uD83D\uDE4B Rudderstack - Is the session launched?", {
            sessionIsStarted: sessionIsStarted,
            rudderstackSessionId: rudderAnalytics.getSessionId()
        });
        return sessionIsStarted;
    };
    if (startRudderstackOnInit) {
        loadRudderstack();
    }
    var cookiesConsentProvider = (0, _didomi.Didomi)({
        id: (_sdk_didomi = sdk.didomi) === null || _sdk_didomi === void 0 ? void 0 : _sdk_didomi.noticeId,
        privacyPolicyURL: (_sdk_didomi1 = sdk.didomi) === null || _sdk_didomi1 === void 0 ? void 0 : _sdk_didomi1.privacyPolicyURL,
        debug: debug,
        locale: locale
    });
    var getUserTraitsRudderstack = function() {
        return rudderAnalytics.getUserTraits() || {};
    };
    var getUserIdRudderstack = function() {
        return rudderAnalytics.getUserId() || null;
    };
    var identifyRudderstack = function() {
        var traits = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, userId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, apiOptions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, callback = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
        if (isQueueNeeded()) {
            var priority = (traits === null || traits === void 0 ? void 0 : traits.unleash_experiment_info) || !eventsQueue.some(function(evt) {
                return evt.event === identifyRudderstack;
            }) ? 0 : 100;
            queueEvent({
                eventFunc: identifyRudderstack,
                args: [
                    traits,
                    userId,
                    apiOptions,
                    callback
                ],
                priority: priority
            });
            return;
        }
        var overridedApiOptions = _object_spread_props._(_object_spread._({}, apiOptions), {
            anonymousId: rudderAnalytics.getAnonymousId()
        });
        var traitsObj = _object_spread_props._(_object_spread._({}, traits === null ? getUserTraitsRudderstack() : traits, _utils.dynamicTraitsProperties, cookiesConsentProvider.getUserConsents()), {
            ip_country: userCountry || ""
        });
        var cleanedTraits = (0, _utils.removedReservedKeywordProperties)(traitsObj);
        var cleanedUserId = userId === _constants1.ZERO_UUID || !userId ? "" : userId;
        var rudderUserId = getUserIdRudderstack();
        rudderUserId = rudderUserId === _constants1.ZERO_UUID || !rudderUserId ? "" : rudderUserId;
        if (!(0, _lodashisequal.default)(cleanedTraits, getUserTraitsRudderstack()) || cleanedUserId !== rudderUserId) {
            ;
            rudderAnalytics.identify(cleanedUserId, cleanedTraits, overridedApiOptions, function() {
                var messageInfo = cleanedUserId ? '\uD83D\uDC64 Rudderstack - Current user is identified with userId "'.concat(cleanedUserId, '"') : "\uD83E\uDD78 Rudderstack - This user is anonymous";
                logger.info(messageInfo, {
                    cleanedUserId: cleanedUserId,
                    anonymousId: overridedApiOptions.anonymousId,
                    cleanedTraits: cleanedTraits
                });
                (0, _runCallback.runCallback)(callback);
            });
        } else {
            logger.debug("💸 Identify not sent because it was not updating user id or user traits.");
        }
    };
    var returnSessionIdIfExists = function() {
        var currentUserId = rudderAnalytics.getUserId();
        var sessionUserId = sessionId;
        if (sessionUserId && sessionUserId.length > 0 && currentUserId === "") {
            logger.info("\uD83D\uDD04 Rudderstack - User sessionId has been updated", {
                sessionUserId: sessionUserId,
                currentUserId: currentUserId
            });
            return sessionUserId;
        }
        return currentUserId;
    };
    var reIdentifyUserIfNeeded = function() {
        var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
            forceIdentify: false
        };
        if (isQueueNeeded()) {
            queueEvent({
                eventFunc: reIdentifyUserIfNeeded,
                args: [
                    props
                ]
            });
            return;
        }
        var forceIdentify = props.forceIdentify;
        var currentSessionId = returnSessionIdIfExists();
        var mustBeUpdated = (0, _utils.checkCurrentUserTraits)(getUserTraitsRudderstack()).mustBeUpdated;
        var sessionIsStarted = sessionIsStartedRudderstack();
        if (!sessionIsStarted || sessionId || mustBeUpdated || forceIdentify) {
            logger.info("\uD83D\uDC64 Rudderstack - reIdentifyUserIfNeeded", currentSessionId);
            identifyRudderstack(getUserTraitsRudderstack(), currentSessionId);
        }
    };
    var trackRudderstack = function(event, properties, apiOptions, callback) {
        if (isQueueNeeded()) {
            queueEvent({
                eventFunc: trackRudderstack,
                args: [
                    event,
                    properties,
                    apiOptions,
                    callback
                ]
            });
            return;
        }
        if (!event) {
            logger.error('\uD83D\uDCC8 Rudderstack.track Error "'.concat(event, '" : "event" arg is not defined. String is required'));
            return;
        }
        // Do not send event if service is missing
        if (!properties.service) {
            logger.error('\uD83D\uDCC8 Rudderstack.track Error "'.concat(event, '" : Prevent event emission due to missing service property'));
            return;
        }
        reIdentifyUserIfNeeded();
        var extendedProps = (0, _utils.extendedProperties)(properties, locale);
        var cleanedProperties = (0, _utils.removedUselessEventProperties)(extendedProps);
        // Event sent in batch are put in a buffer
        if (batchBuffer.isEventBatchable(event)) {
            batchBuffer.addEvent(event, cleanedProperties, function(batchEventName, events) {
                ;
                rudderAnalytics.track(batchEventName, {
                    batch: events
                }, apiOptions, function() {
                    logger.info("\uD83D\uDCC8 Rudderstack - Batch Event has been tracked", {
                        events: events
                    });
                    (0, _runCallback.runCallback)(callback);
                });
            });
            logger.info('\uD83D\uDCC8 Rudderstack - Event "'.concat(event, '" has been put in batch buffer'), {
                properties: cleanedProperties
            });
        } else {
            ;
            rudderAnalytics.track(event, cleanedProperties, apiOptions, function() {
                logger.info('\uD83D\uDCC8 Rudderstack - Event "'.concat(event, '" has been tracked'), {
                    properties: cleanedProperties
                });
                (0, _runCallback.runCallback)(callback);
            });
        }
    };
    var pageRudderstack = function(category, properties, apiOptions, callback) {
        var _window_location, _window;
        var currentCategory = category || (0, _getPageViewCategoryAccordingToTheStack.getPageViewCategoryAccordingToTheStack)();
        if (isQueueNeeded()) {
            queueEvent({
                eventFunc: pageRudderstack,
                args: [
                    category,
                    properties,
                    apiOptions,
                    callback
                ],
                priority: 1
            });
            return;
        }
        reIdentifyUserIfNeeded();
        var pageName = (properties === null || properties === void 0 ? void 0 : properties.page_name) || "";
        var extendedProps = (0, _utils.extendedProperties)(_object_spread._({
            content_type: (0, _defineDefaultContentType.defineDefaultContentType)(((_window = window) === null || _window === void 0 ? void 0 : (_window_location = _window.location) === null || _window_location === void 0 ? void 0 : _window_location.pathname) || "")
        }, properties, (0, _refererParams.getRefererParamsToPageView)()), locale);
        var cleanedProperties = (0, _utils.removedUselessPageProperties)(extendedProps);
        rudderAnalytics.page(currentCategory, pageName, cleanedProperties, apiOptions, function() {
            logger.info("\uD83D\uDCC8 Rudderstack - Current page has been tracked", currentCategory, pageName, cleanedProperties);
            (0, _runCallback.runCallback)(callback);
        });
    };
    var init = function() {
        ;
        rudderAnalytics.setAnonymousId((0, _cookie.getCookie)("visitor_id"));
        cookiesConsentProvider.onConsentChange(function() {
            reIdentifyUserIfNeeded({
                forceIdentify: true
            });
            (0, _sendUserConsents.sendUserConsents)(logger);
            pageRudderstack((0, _getPageViewCategoryAccordingToTheStack.getPageViewCategoryAccordingToTheStack)());
        });
        cookiesConsentProvider.load(rudderAnalytics.getUserId() || "");
    };
    init();
    var sendToRudderstack = function() {
        var eventName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", payloadData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        if (!eventName || !payloadData) {
            return;
        }
        var isPageViewEvent = eventName.startsWith("page_view");
        if (isPageViewEvent) {
            pageRudderstack((0, _getPageViewCategoryAccordingToTheStack.getPageViewCategoryAccordingToTheStack)(), payloadData, {});
        } else {
            var currentService = options.service || _constants1.TRACKING_DEFAULT_SERVICE;
            var defaultTrackEventData = {
                trackee_locale: options.trackeeLocale,
                referrer: payloadData.referrer,
                uri: payloadData.uri,
                query_parameters: payloadData.query_parameters
            };
            var eventData = payloadData;
            var eventNameOverriden = eventName;
            var eventDataOverriden = eventData;
            if (typeof options.alternativePayload !== "undefined") {
                var _options_alternativePayload = options.alternativePayload, tmp = _options_alternativePayload.eventName, rudderstackEventName = tmp === void 0 ? null : tmp, tmp1 = _options_alternativePayload.eventProps, rudderstackProps = tmp1 === void 0 ? null : tmp1, _options_alternativePayload_eventStrategy = _options_alternativePayload.eventStrategy, eventStrategy = _options_alternativePayload_eventStrategy === void 0 ? _constants.EVENTS_PROPERTIES_STRATEGY.MERGE : _options_alternativePayload_eventStrategy;
                eventNameOverriden = rudderstackEventName || eventName;
                if (eventStrategy === _constants.EVENTS_PROPERTIES_STRATEGY.OVERWRITE) {
                    eventDataOverriden = rudderstackProps || eventData;
                } else {
                    eventDataOverriden = _object_spread._({}, eventData, rudderstackProps || {});
                }
                currentService = eventDataOverriden.service || currentService;
                if (rudderstackEventName || rudderstackProps) {
                    logger.info('\uD83D\uDCC8 Rudderstack - alternativePayload "'.concat(eventName, '" is overrided by'), {
                        eventNameOverriden: eventNameOverriden,
                        eventDataOverriden: eventDataOverriden
                    });
                }
            }
            trackRudderstack(eventNameOverriden, _object_spread_props._(_object_spread._({}, eventDataOverriden, defaultTrackEventData), {
                service: currentService
            }));
        }
    };
    return {
        send: skipBot(function() {
            var eventName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", payloadData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            sendToRudderstack(eventName, payloadData, options);
        }),
        sessionIsStarted: sessionIsStartedRudderstack,
        getUserId: getUserIdRudderstack,
        getUserTraits: getUserTraitsRudderstack,
        setRefererParams: function(data, options) {
            return (0, _refererParams.setRefererParamsToPageView)(data, options);
        },
        getRefererParams: function(keyName, options) {
            return (0, _refererParams.getRefererParamsToEvent)(keyName, options);
        },
        getUserConsents: function(purpose) {
            return cookiesConsentProvider.getUserConsents(purpose);
        },
        checkDidomi: function(callback) {
            cookiesConsentProvider === null || cookiesConsentProvider === void 0 ? void 0 : cookiesConsentProvider.checkDidomi(callback);
        },
        start: function() {
            if (!startRudderstackOnInit) {
                loadRudderstack();
            }
        },
        /**
     * Send identify event to Rudderstack
     * https://www.rudderstack.com/docs/event-spec/standard-events/identify/
     *
     */ identify: skipBot(function() {
            var traits = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, userId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, apiOptions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, callback = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
            identifyRudderstack(traits, userId || sessionId, apiOptions, callback);
        }),
        /**
     * Send page event to Rudderstack
     * https://www.rudderstack.com/docs/sources/event-streams/sdks/rudderstack-javascript-sdk/supported-api/#page
     *
     */ page: skipBot(function(category, properties) {
            var apiOptions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, callback = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
            pageRudderstack(category, properties, apiOptions, callback);
        }),
        /**
     * Send track event to Rudderstack
     * https://www.rudderstack.com/docs/sources/event-streams/sdks/rudderstack-javascript-sdk/supported-api/#track
     *
     */ /* eslint-disable-next-line max-params */ track: skipBot(function(event, properties) {
            var apiOptions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, callback = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
            trackRudderstack(event, properties, apiOptions, callback);
        })
    };
};

//# sourceMappingURL=index.js.map